import React from 'react';
import emojiImage from '../../../images/BlogPage/MrSeaMiami_Emoji_LeonardoGalarza.png';

const BlogHeroSection = () => {
  return (
    <section className="blog-hero-section">
      <div className="blog-hero-section__background">
        <div className="blog-hero-section__overlay"></div>
      </div>
      
      <div className="blog-hero-section__content">
        <div className="container">
          <div className="blog-hero-section__text-content">
            <h2 className="blog-hero-section__subtitle">
              Inside Mr. Sea
            </h2>
            <h1 className="blog-hero-section__title">
              Welcome to the Mr. Sea Blog
            </h1>
            <div className="blog-hero-section__emoji">
              <img src={emojiImage} alt="Mr. Sea Emoji" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogHeroSection; 